import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import api from '../services/api'

import './styles/Login.css';

const swal = withReactContent(Swal)

function ForgotPw() {

    function login(e) {
        e.preventDefault();
        //Pega valores do form
        const form = document.getElementById('loginForm');
        const data = new FormData(form);

        if (data.get('login') === '') {
            swal.fire('Informe seu login!', 'Informe seu login', 'warning')
            return
        }


        //Converte FormData em JSON
        var object = {};

        data.forEach(function (value, key) {
            object[key] = value;
        });
        object.host = window.location.href
        //Checa no servidor
        api.post('usuario_externo/esqueceuSenha', object)
            .then(function (response) {
                // swal.fire('Link para redefinição de senha foi enviado para o seu e-mail!', 'Redefinição de senha', "success")
                swal.fire('Link para redefinição de senha foi enviado para o seu e-mail!', '', 'success')
                    .then((result) => {
                        if (result.value) {
                            window.location.href = '/sistema/login'
                        }
                    })


            })
            .catch(function (error) {
                swal.fire('Usuário não encontrado!', '', "error")
            });
    }

    return (
        <div className="Login">
            <div className="form">
                <img alt="fr_logo" src={require('../imgs/logo2.png')} title="KSA Clube" className="logo" />
                Esqueceu sua senha?
                <form className="form-signin" id="loginForm" onSubmit={login}>
                    <div className="form-label-group">
                        <input type="text" id="login" name="login" className="loginInput" placeholder="Usuário" />
                        <label htmlFor="login">Usuário</label>
                    </div>
                    <button className="loginButton" type="submit" rel="nofollow">
                        <span><p className='loginButtonText'>OK</p></span>
                    </button>

                </form>
            </div>
        </div>
    );
}

export default ForgotPw;
